import callApi from 'lib/callApi';

export function getExportCsvUrlParams(
  companyId: number,
  ordering: string,
  scannerType: string,
  searchData: string,
  checkedHostIds: number[],
  selectedEndpointsFilter: string,
  csv_type?: string,
) {
  if (companyId === -1) return '';
  const params = {
    company_id: companyId,
    scanner_type: scannerType,
    search: searchData,
  };
  if (checkedHostIds?.length > 0) {
    params['host_id_list'] = checkedHostIds;
  }
  if (ordering && ordering !== 'name') {
    params['ordering'] = `${ordering},name`;
  }
  if (selectedEndpointsFilter) {
    params['filter'] = selectedEndpointsFilter;
  }
  if (csv_type && csv_type !== '') {
    params['csv_type'] = csv_type;
  }

  return params;
}

export async function loadEndPointsData(
  company_id: number,
  pageSize: number,
  currentPage: number,
  ordering: string,
  scanner_type: string,
  search_data: string,
  selectedEndpointsFilter: string,
): Promise<any> {
  if (company_id === undefined) {
    throw Error('company_id is required.');
  }

  // if company_id is not yet available then do not proceed further
  if (company_id === -1) return;

  if (ordering && ordering !== 'big_ip') ordering = `${ordering},big_ip`;

  let url = `endpoints/?company=${company_id}&filter=${selectedEndpointsFilter}&search=${search_data}&offset=${
    pageSize * (currentPage - 1)
  }&limit=${pageSize}&ordering=${ordering}`;

  if (scanner_type && scanner_type !== '')
    url += '&scanner_type=' + scanner_type;

  const data = await callApi(url, 'GET', {})
    .then((res) => {
      if ((res.status === 201 || res.status === 200) && res.data.results) {
        return {
          items: res.data.results,
          count: res.data.count,
        };
      } else {
        console.error({
          function: 'loadEndPointsData',
          error: `Unexpected response: ${res.status}`,
          res,
        });
      }
    })
    .catch((err) => {
      throw err;
    });

  return data;
}

export async function fetchEPDetail(id) {
  let url = `endpoints/${id}/`;
  const data = await callApi(url, 'GET', {})
    .then((res) => {
      if (res.data) {
        return res.data;
      }
    })
    .catch((err) => {
      throw err;
    });
  return data;
}
